import { NavLink, NavLinkProps } from 'react-router-dom';

/**
 * This is a wrapper around the NavLink component from react-router-dom that removes the default underline styling.
 */
export function UnstyledNavLink(props: NavLinkProps) {
  return <NavLink {...props} style={{ textDecoration: 'none' }} />;
}
